import React from 'react';
import { ActivityIcon } from 'lucide-react';
export const Header = () => {
  return <header className="bg-gradient-to-r from-blue-900 to-blue-800 text-white p-4 flex justify-between items-center shadow-md" data-id="element-115">
      <div className="flex items-center" data-id="element-116">
        <ActivityIcon className="h-6 w-6 mr-2" data-id="element-117" />
        <h2 className="text-xl font-bold" data-id="element-118">Active Life Journal</h2>
      </div>
      <div className="text-sm bg-white/20 px-3 py-1 rounded-full" data-id="element-119">
        Advertorial
      </div>
    </header>;
};